/**
 * @desc override to ui-select to close when user clicks the toggle
 * @example <ui-select ui-select-toggle-close></ui-select>
 */
;(function () {
  angular
    .module('contrast.ui-select')
    .directive('uiSelectToggleClose', uiSelectToggleClose)

  function uiSelectToggleClose($) {
    'ngInject'

    return {
      require: 'uiSelect',
      link: link
    }

    function link(scope, element, attrs, $select) {
      $(element).on('click', '.ui-select-toggle', function (event) {
        if (
          $(this.parentElement.parentElement).find('.ui-select-choices.ng-hide')
            .length == 0
        ) {
          $select.toggle(event)
          scope.$apply()
        }
      })
    }
  }
})()
